import { render, staticRenderFns } from "./o-preloader.vue?vue&type=template&id=215eef00&"
import script from "@/objects/o-preloader/o-preloader.js?vue&type=script&lang=js&"
export * from "@/objects/o-preloader/o-preloader.js?vue&type=script&lang=js&"
import style0 from "@/objects/o-preloader/o-preloader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports